import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { FailedSolutions } from '../components/FailedSolutions';
import { MethodSection } from '../components/MethodSection';
import { WhatYouGet } from '../components/WhatYouGet';
import { AudienceSection } from '../components/AudienceSection';
import { HowItWorks } from '../components/HowItWorks';
import { ProofSection } from '../components/ProofSection';
import { FAQSection } from '../components/FAQSection';
import { OfferSection } from '../components/OfferSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-slate-900 font-sans selection:bg-amber-500/30" data-id="element-213">
      <HeroSection data-id="element-214" />
      <ProblemSection data-id="element-215" />
      <FailedSolutions data-id="element-216" />
      <MethodSection data-id="element-217" />
      <WhatYouGet data-id="element-218" />
      <AudienceSection data-id="element-219" />
      <HowItWorks data-id="element-220" />
      <ProofSection data-id="element-221" />
      <FAQSection data-id="element-222" />
      <OfferSection data-id="element-223" />
      <Footer data-id="element-224" />
    </div>;
}